import { Reward } from '@/models';
import { AccountManagementEvent } from '@/services/analytics/events';
import { InteractionTrackingType } from '@/services/analytics/platforms/adobe-analytics/models';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardOffer',
})
export default class CmgRewardOffer extends Vue {
  @Prop({ type: Object, required: true })
  reward!: Reward;
  hover = false;

  onClickRewardOffer(event: any) {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: this.reward.title + AnalyticsEventAction.RewardViewClick,
      label: AnalyticsEventLabel.RewardViewClick + this.reward.title,
    });
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('rewardDetail', true, { reward: this.reward });
    this.$services.ui.firstFocus();
    this.$services.analytics.send(
      new AccountManagementEvent(InteractionTrackingType.RewardsViewed, [], this.reward.title),
    );
  }
}
